import { render, staticRenderFns } from "./ViewProduit.vue?vue&type=template&id=48fcd6f1&"
import script from "./ViewProduit.vue?vue&type=script&lang=js&"
export * from "./ViewProduit.vue?vue&type=script&lang=js&"
import style0 from "./ViewProduit.vue?vue&type=style&index=0&id=48fcd6f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports